import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMemberArchive,
  AddTeamMember,
  AddTitleMember,
  deleteMember,
  deleteMemberTitle,
  getMember,
  getMembersCSV,
  getTeams,
  getMembersXLSX,
  updateMember,
} from '../../../../redux/MainAction';
import MemberEditModal from './MemberEditModal';
import { Button } from 'reactstrap';
import PaginationComponent from '../../filters/PaginationComponent';
import CollapsibleItemsList from '../../../../components/Layout/CollapsibleItemsList';
import { downloadCSV, downloadXLS } from '../../../../helpers/helpers';
import { FaFileCsv, FaFileExcel } from 'react-icons/fa';

const MembersList = () => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.Webtracker.member);
  const tmlist = useSelector((state) => state.Webtracker.teams);
  const titlelist = useSelector((state) => state.Webtracker.title);

  const [showReset, setShowReset] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  const [filter, setFilter] = useState({
    teamId: undefined,
    role: undefined,
    titleIds: undefined,
    search: '',
  });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };

    dispatch(getMember({ ...data, showArchived: false }));
  };

  const [editableRows, setEditableRows] = useState([]);
  const [tmsToggle, setTmsToggle] = useState(false);
  const [tmsToggle2, setTmsToggle2] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editID, setEditID] = useState('');

  // Function to toggle the modal visibility
  const toggleModal = (id) => {
    setIsModalOpen(!isModalOpen);
    setEditID(id);
  };

  useEffect(() => {
    setEditableRows(
      list?.rows?.map((item) => ({
        ...item,
        isWeeklyHours: false,
        weeklyHours: item.userEmployeeRelation.weeklyHours || 'Add',
        isRateHourly: false,
        rateHourly: item.userEmployeeRelation.rateHourly || 'Add',
      }))
    );
    setTotalPages(Math.ceil(list.count / itemsPerPage));
  }, [list]);

  useEffect(() => {
    if (!tmlist || !Array.isArray(tmlist?.rows)) dispatch(getTeams());
  }, [tmlist]);

  // Handlers for weeklyHours editing
  const handleTextClick = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isWeeklyHours: true } : row
      )
    );
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleTextChange = (e, id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, weeklyHours: e.target.value } : row
      )
    );
  };

  const handleBlur = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isWeeklyHours: false } : row
      )
    );
  };

  const handleKeyPress = (e, id) => {
    if (e.key === 'Enter') {
      handleBlur(id);
      var payload = {
        id: id,
        weeklyHours: e.target.value,
      };
      dispatch(updateMember(payload));
    }
  };

  // Handlers for rateHourly editing
  const handleMobileClick = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isRateHourly: true } : row
      )
    );
  };

  const handleMobileChange = (e, id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, rateHourly: e.target.value } : row
      )
    );
  };

  const handleMobileBlur = (id) => {
    setEditableRows(
      editableRows.map((row) =>
        row.id === id ? { ...row, isRateHourly: false } : row
      )
    );
  };

  const handleMobileKeyPress = (e, id) => {
    if (e.key === 'Enter') {
      handleMobileBlur(id);
      var payload = {
        id: id,
        rateHourly: e.target.value,
      };
      dispatch(
        updateMember(payload, {
          offset: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
        })
      );
    }
  };

  const handleRemoveTeam = (temsID, userId) => {
    var rem = {
      teamId: temsID,
      userId: userId,
    };
    dispatch(
      deleteMember(rem, {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      })
    );
  };
  const handleRemoveTeam2 = (temsID, userId) => {
    var remT = {
      titleId: temsID,
      userId: userId,
    };
    dispatch(
      deleteMemberTitle(remT, {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      })
    );
  };

  const onSelectHandle = (teamId, userID) => {
    var adMem = {
      teamId: teamId,
      userId: userID,
    };
    dispatch(
      AddTeamMember(adMem, {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      })
    );
    setTmsToggle(false);
  };
  const onSelectHandle1 = (teamId, userID) => {
    var adMem = {
      titleId: teamId,
      userId: userID,
    };
    dispatch(
      AddTitleMember(adMem, {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      })
    );
    setTmsToggle2(false);
  };

  const handleApply = (e) => {
    e.preventDefault();

    const payload = {
      offset: 0,
      limit: 10,
      showArchived: false,
    };

    if (filter?.role !== '') {
      payload.role = filter.role;
    }
    if (filter?.titleIds) {
      payload.titleIds = [filter.titleIds];
    }

    if (filter?.teamId !== '') {
      payload.teamId = filter.teamId;
    }
    if (filter?.search !== '') {
      payload.search = filter.search;
    }

    dispatch(getMember(payload));
    setShowReset(true);
  };

  const memberArchive = (id) => {
    var data = {
      id: id,
    };
    dispatch(addMemberArchive(data));
  };

  const handleReset = (e) => {
    e.preventDefault();

    const pay = {
      offset: 0,
      limit: 10,
      showArchived: false,
    };
    dispatch(getMember(pay));
    setShowReset(false);
    setFilter({ teamId: '', role: '', titleIds: '' });
  };

  async function downloadCSVHandler(isCSV) {
    const payload = {
      showArchived: false,
    };

    if (filter?.role !== '') {
      payload.role = filter.role;
    }
    if (filter?.titleIds) {
      payload.titleIds = [filter.titleIds];
    }

    if (filter?.teamId !== '') {
      payload.teamId = filter.teamId;
    }
    if (filter?.search !== '') {
      payload.search = filter.search;
    }

    if (isCSV) {
      const csv = await dispatch(getMembersCSV(payload));
      downloadCSV(csv, 'Members Report');
    } else {
      const xlsx = await dispatch(getMembersXLSX(payload));
      downloadXLS(xlsx, 'Members Report');
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
        <div
          className="d-flex justify-content-start align-items-center"
          style={{ gap: '10px' }}
        >
          <div className="fillSelect">
            <input
              type="text"
              placeholder="Search by name / email..."
              name="search"
              className="form-control py-2 ps-3 rounded-3 border-secondary-subtle"
              value={filter?.search}
              onChange={onChangeFilter}
            />
          </div>

          <div className="fillSelect">
            <i className="mdi mdi-briefcase font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="teamId"
              value={filter?.teamId}
              onChange={onChangeFilter}
            >
              <option value={''}>All Teams</option>
              {tmlist?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="fillSelect">
            <i className="mdi mdi-briefcase font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="titleIds"
              value={filter?.titleIds}
              onChange={onChangeFilter}
            >
              <option value={''}>All Title</option>
              {titlelist?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="fillSelect">
            <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="role"
              value={filter?.role}
              onChange={onChangeFilter}
            >
              <option value="">All Type</option>
              <option value="EXECUTIVE-MANAGER">Executive Manager</option>
              <option value="OWNER">Owner</option>
              <option value="TEAM-MANAGER">Team Manager</option>
              <option value="PROJECT-MANAGER">Project Manager</option>
              <option value="EMPLOYEE">Employee</option>
            </select>
          </div>
          <Button
            className="d-flex align-items-center justify-content-center"
            style={{ padding: '6px 14px' }}
            size="sm"
            color="primary"
            onClick={handleApply}
          >
            <i className="ion-ios7-search font-20"></i>
          </Button>
          {showReset ? (
            <Button
              className="d-flex align-items-center justify-content-center"
              style={{ padding: '6px 13px' }}
              size="sm"
              color="danger"
              onClick={handleReset}
            >
              <i className="mdi mdi-close font-20"></i>
            </Button>
          ) : (
            ''
          )}

          <Button
            color="success"
            size="sm"
            className="mr-2 d-flex align-items-center"
            onClick={() => downloadCSVHandler(true)}
          >
            <FaFileCsv className="mr-1" /> CSV
          </Button>
          {/* <Button
            color="primary"
            size="sm"
            className="d-flex align-items-center"
            onClick={() => downloadCSVHandler()}
          >
            <FaFileExcel className="mr-1" /> XLSX
          </Button> */}
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table
          id="datatable"
          className="table dt-responsive nowrap table-vertical"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th className="text-nowrap">No.</th>
              <th className="text-nowrap">Member</th>
              <th className="text-nowrap">Member Limit (wk)</th>
              <th className="text-nowrap">Hourly Rate</th>
              <th className="text-nowrap">Member Type</th>
              <th className="text-nowrap">Team</th>
              <th className="text-nowrap">Job Title</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {editableRows?.length > 0 ? (
              editableRows?.map((item, idx) => {
                const selectedId = item?.teams?.map((selct) => selct?.id);
                const unselectedTeams = tmlist?.rows?.filter(
                  (team) => !selectedId?.includes(team.id)
                );
                const selectedTitle = item?.titles?.map((selct) => selct?.id);
                const unselectedTitles = titlelist?.rows?.filter(
                  (title) => !selectedTitle.includes(title.id)
                );

                return (
                  <tr key={item.id}>
                    <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                    <td className="text-nowrap">
                      <div className="d-flex align-items-center">
                        <div
                          style={{ lineHeight: 1 }}
                          className="border rounded p-2 text-white bg-info text-uppercase"
                        >
                          {item.firstName.charAt(0)}
                          {item.lastName.charAt(0)}
                        </div>

                        <div className="ml-2" style={{ lineHeight: 1 }}>
                          <div className="font-weight-bold text-capitalize">
                            {item.firstName} {item.lastName}
                          </div>
                          <small className="fs-7">{item.email}</small>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div
                        className="col-3 d-flex justify-content-between align-items-center text-info border border-info rounded"
                        style={{ maxWidth: '80px', padding: '0 5px' }}
                      >
                        <span className="text-nowrap">
                          {item.weeklyHours !== 'Add' ? (
                            <i className="mdi mdi-pencil"></i>
                          ) : (
                            '+'
                          )}
                        </span>
                        {item.isWeeklyHours ? (
                          <input
                            type="number"
                            value={item.weeklyHours}
                            onChange={(e) => handleTextChange(e, item.id)}
                            onBlur={() => handleBlur(item.id)}
                            onKeyPress={(e) => handleKeyPress(e, item.id)}
                            className="edit_input"
                            autoFocus
                          />
                        ) : (
                          <span
                            onClick={() => handleTextClick(item.id)}
                            style={{ cursor: 'pointer' }}
                            className="text-nowrap"
                          >
                            {item.weeklyHours}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div
                        className="d-flex justify-content-between align-items-center text-info border border-info rounded"
                        style={{ maxWidth: '100px', padding: '0 5px' }}
                      >
                        <span>
                          {item.rateHourly !== 'Add' ? (
                            <i className="mdi mdi-coin"></i>
                          ) : (
                            '+'
                          )}
                        </span>
                        {item.isRateHourly ? (
                          <input
                            type="number"
                            value={item.rateHourly}
                            onChange={(e) => handleMobileChange(e, item.id)}
                            onBlur={() => handleMobileBlur(item.id)}
                            onKeyPress={(e) => handleMobileKeyPress(e, item.id)}
                            className="edit_input"
                            autoFocus
                          />
                        ) : (
                          <span
                            onClick={() => handleMobileClick(item.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {item.rateHourly}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="text-nowrap">
                      {item?.userEmployeeRelation?.role}
                    </td>
                    <td>
                      <div className="">
                        {item?.teams?.length > 0 ? (
                          <CollapsibleItemsList
                            items={item.teams}
                            onRemove={(teamId) =>
                              handleRemoveTeam(teamId, item.id)
                            }
                            title="Teams"
                          />
                        ) : (
                          ''
                        )}
                        {!tmsToggle ? (
                          <div
                            className="add_to_new"
                            onClick={() => setTmsToggle(!tmsToggle)}
                          >
                            <span>Add to team</span>
                          </div>
                        ) : (
                          <select
                            className="form-control font-14"
                            onChange={(e) =>
                              onSelectHandle(e.target.value, item.id)
                            }
                          >
                            <option>Select teams</option>
                            {unselectedTeams?.map((tms, idx) => (
                              <option key={idx} value={tms?.id}>
                                {tms?.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </td>
                    <td className="text-nowrap">
                      <div className="member_add_new">
                        {item?.titles?.length > 0 ? (
                          <CollapsibleItemsList
                            items={item.titles}
                            onRemove={(titleId) =>
                              handleRemoveTeam2(titleId, item.id)
                            }
                            title="Job Titles"
                          />
                        ) : (
                          ''
                        )}
                        {!tmsToggle2 ? (
                          <div
                            className="add_to_new"
                            onClick={() => setTmsToggle2(!tmsToggle2)}
                          >
                            <span>Add title</span>
                          </div>
                        ) : (
                          <select
                            className="form-control font-14"
                            onChange={(e) =>
                              onSelectHandle1(e.target.value, item.id)
                            }
                          >
                            <option value="">Select title</option>
                            {unselectedTitles?.map((tms, idx) => (
                              <option key={idx} value={tms?.id}>
                                {tms?.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <i
                          className="fa fa-pencil font-16 Edit_Icons"
                          style={{ cursor: 'pointer' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit Details"
                          onClick={() => toggleModal(item?.id)}
                        ></i>
                        {item?.userEmployeeRelation?.role !== 'OWNER' ? (
                          <i
                            className=" mdi mdi-archive font-16 Edit_Icons"
                            style={{ cursor: 'pointer' }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Archive user"
                            onClick={() => memberArchive(item?.id)}
                          ></i>
                        ) : (
                          ''
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <PaginationComponent
        count={totalPages}
        page={page}
        onPageChange={handlePageChange}
      />
      <MemberEditModal
        open={isModalOpen}
        onClose={toggleModal}
        m_id={editID}
        filters={{
          offset: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
        }}
      />
    </div>
  );
};

export default MembersList;
